<template>
  <div class='core'>
    <div class='layui-layer-title' style='cursor: move;'>{{ title }}</div>
    <div class='layui-layer-content'>
      <div class='layui-layer-wrap'>
        <div class='form-collapse'>
          <div class='info'>
            <layui-form ref='qrCodeManageMngRef' :show-form='true' :after-save='handleAfterSave'
                        :rule='qrCodeManageFormRule' :requestUniqueId='requestId'>
              <template slot-scope='{scope}'>
                <div class='layui-form'>
                  <template>
                    <layui-collapse>
                      <div class='layui-colla-item'>
                        <h2 class='layui-colla-title'>绑定门店</h2>
                        <div class='layui-colla-content layui-show'>
                          <div class='layui-form-item-two'>
                            <div class='layui-form-item-left'>
                              <div class='pub-form'>
                                <div class='layui-form-item'>
                                  <label class='layui-form-label'>二维码编号：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <input type='text' v-model='config.form.QR_CODE_NUM' autocomplete='off'
                                           :disabled="true" class='layui-input layui-disabled' name='QR_CODE_NUM'/>
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'>二维码内容：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <input type='text' v-model='config.form.QR_CODE_CONTENT' autocomplete='off'
                                           :disabled="true" class='layui-input layui-disabled' name='QR_CODE_CONTENT'/>
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'><span class="x-red">*</span>门店：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <layui-tableselect
                                      name="STORE_ID"
                                      table-name="YW_CUS_STORE_DETAIL_V1"
                                      @selectChange='storeOnChange($event)'
                                      :renderText="renderClientText"
                                      input-width="100%"
                                      table-width="800px"
                                      text-width="100%"
                                      text-field="STORE_NAME"
                                      value-field="STORE_ID"
                                      queryFields="CLIENT_NAME,STORE_NAME,BRAND_NAME"
                                      v-model="scope.editRow.STORE_ID"
                                      tip="请选择客户"
                                      :sort="['CREATE_TIME:DESC']"
                                      :page-size="50"
                                      :page-range="6"
                                      :page-options="[15, 25, 50, 100]"
                                      style="width:400px"
                                    >
                                      <div>
                                        <div radio="true"></div>
                                        <div field="STORE_NAME" title="门店" width="220"></div>
                                        <div field="CLIENT_NAME" title="客户" width="280"></div>
                                        <div field="BRAND_NAME" title="品牌" width="120"></div>
                                        <div field="MANAGER_NAME" title="项目经理" width="120"></div>
                                        <div field="PROVINCE_DESC" title="省" ></div>
                                        <div field="CITY_DESC" title="市" ></div>
                                        <div field="DISTRICT_DESC" title="县" ></div>
                                      </div>
                                    </layui-tableselect>
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'>备注：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <textarea v-model='config.form.MEMO' autocomplete='off' class='layui-textarea'
                                              name='MEMO' placeholder='请输入备注'/>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </layui-collapse>
                  </template>
                </div>

                <div class='layui-form-btn'>
                  <div class='layui-footer'>
                    <button class='layui-btn refresh' title='关闭' @click='onCancelBtn()'>关 闭</button>
                    <button class='layui-btn' title='保存' @click='onSaveBtn()'>保 存</button>
                  </div>
                </div>
              </template>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      requestId: 'qrCodeManageMngFormRequest',
      qrCodeManageFormRule: {
        STORE_ID: {
          required: {message: '门店不能为空'}
        },
      },
      config: {form: {}},
      formData: {},
      title: ''
    }
  },

  mounted() {
    if (this.tabParam) {
      this.formData = this.tabParam.editRow
      this.tableObj = this.tabParam.tableObj
      this.formType = this.tabParam.formType
      this.title = this.tabParam.title

      if (this.formType === 'edit') {
        this.config.form = this.formData
      }
    }
  },

  methods: {
    handleAfterSave() {
      this.baseComponent.loadComponentByName('qrCodeManage')

      if (this.tableObj) {
        this.tableObj.pageInfo.pageIndex = 1
        this.tableObj.load()
      }
    },

    renderClientText(row) {
      if (row) {
        if (!row.STORE_ID) {
          return '--请选择--'
        } else {
          var arr = [];
          arr.push('门店【 ' + row['STORE_NAME'] + ' 】');
          arr.push('客户【 ' + row['CLIENT_NAME'] + ' 】');
          arr.push('品牌【 ' + row['BRAND_NAME'] + ' 】');
          this.storeName = arr.join(" ")
          return arr.join(" ");
        }
      }
    },

    onCancelBtn() {
      // this.baseComponent.loadComponentByName('qrCodeManage')
      this.baseComponent.closeComponent(this.tabParam.cloneMenu);
    },

    onSaveBtn() {
      this.config.form['B_BIND'] = 1
      this.$refs.qrCodeManageMngRef.editRow = this.config.form
      this.$refs.qrCodeManageMngRef.callableSave('YW_QR_CODE')
    },

    storeOnChange(selectData) {
      if (selectData != null && selectData.length > 0) {
        this.config.form['STORE_ID'] = selectData[0].STORE_ID;
        this.config.form['STORE_NAME'] = selectData[0].STORE_NAME;
      } else {
        this.config.form['STORE_ID'] = "";
        this.config.form['STORE_NAME'] = "";
      }
    }


  }
}
</script>




// WEBPACK FOOTER //
// src/components/repairs/qrCodeManage/qrCodeManageForm.vue